import { debounce } from 'lodash';
import { EMAIL_REGEX } from '@/utils/regex';
import { fetcher } from '@/utils/fetcher';

export const isEmailExists = debounce((email: string, resolve) => {
    if (!EMAIL_REGEX.test(email)) {
        return resolve(true);
    }

    fetcher('/api/auth/check-email', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            email
        })
    }).then(res => res.json()).then(res => resolve(res.exists));
}, 300);

export default isEmailExists;
